import { useEffect, useState } from 'react'
import { SceneButton } from './SceneButton'
import '../App.scss';
import { WhoAmI, WebDev, GameDev } from './scenes'

const Home = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const breakpoint = 1100//768;

  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth)
    window.addEventListener("resize", handleWindowResize);

    // Return a function from the effect that removes the event listener
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  const [activeScene, setActiveScene] = useState(0)

  const sceneTitles = ["Who Am I", "Web Development", "Game Development"]
  const sceneTitlesSmall = ["Who Am I", "Web", "Games"]
  const sceneIds = [0, 1, 2]
  
  const handleChangeScene = (id: number) => {
    setActiveScene(id)
  }

  return (
    <div className="app">
      <div className="canvas-group translate" sceneId={activeScene} >
        <WhoAmI activeScene={activeScene} width={width} breakpoint={breakpoint} />
        <WebDev activeScene={activeScene} width={width} breakpoint={breakpoint} />
        <GameDev activeScene={activeScene} width={width} breakpoint={breakpoint} />
      </div>
      <div className='footer'>
        <div className='button-container'>
          {width > breakpoint
            ? sceneIds.map((id) => <SceneButton text={sceneTitles[id]} onclick={() => handleChangeScene(id)} />)
            : sceneIds.map((id) => <SceneButton text={sceneTitlesSmall[id]} onclick={() => handleChangeScene(id)} />)
          }
        </div>
      </div>
    </div>
  )
}

export { Home }